import { DateTime } from "luxon";

import { CoachingData } from "@app/analytics/MeetingReport/types";

export interface CharismaBiasParticipant {
  id: string;
  name: string;
  talkTime: string;
  talkTimePercent: string;
  bias: number | null;
  charisma: number | null;
}

interface CharismaBiasCoachingData {
  my: { bias: number | null; charisma: number | null };
  participants: CharismaBiasParticipant[];
}

export const SAMPLE_COACHING_DATA: CoachingData = {
  fillerWords: {
    moments: [
      {
        id: "01GZCJPJ6RPFBSWCM6XNAVMBES",
        instances: [
          {
            label: "hey",
            count: 1,
            type: "negative",
          },
          {
            label: "kind of",
            count: 1,
            type: "negative",
          },
          {
            label: "like",
            count: 1,
            type: "negative",
          },
          {
            label: "so",
            count: 1,
            type: "negative",
          },
          {
            label: "uh",
            count: 4,
            type: "negative",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:00:52.360-07:00"),
        timestamp: "0:07",
        relativeStartTime: 4.36,
      },
      {
        id: "01GZCJPJ6R3ZSXMH8JWJN3FFEY",
        instances: [
          {
            label: "kind of",
            count: 1,
            type: "negative",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:04:25.511-07:00"),
        timestamp: "3:40",
        relativeStartTime: 217.511,
      },
      {
        id: "01GZCJPJ6R4RS3XHE1D55S5T50",
        instances: [
          {
            label: "like",
            count: 1,
            type: "negative",
          },
          {
            label: "uh",
            count: 1,
            type: "negative",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:04:50.459-07:00"),
        timestamp: "4:05",
        relativeStartTime: 242.459,
      },
      {
        id: "01GZCJPJ6RK8NAV4FJMKGTH013",
        instances: [
          {
            label: "kind of",
            count: 1,
            type: "negative",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:06:00.280-07:00"),
        timestamp: "5:15",
        relativeStartTime: 312.28,
      },
      {
        id: "01GZCJPJ6RG1YECVXNYYKKTGSE",
        instances: [
          {
            label: "kind of",
            count: 1,
            type: "negative",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:11:13.280-07:00"),
        timestamp: "10:28",
        relativeStartTime: 625.28,
      },
      {
        id: "01GZCJPJ6RX32K1VAFDNFT7QE6",
        instances: [
          {
            label: "kind of",
            count: 2,
            type: "negative",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:13:25.760-07:00"),
        timestamp: "12:40",
        relativeStartTime: 757.76,
      },
    ],
    rate: 1.4492753623188406,
    totalCount: 15,
    words: [
      {
        word: "kind of",
        displayValue: "kind of",
        count: 6,
        turns: [
          "01GZCJPJ6RPFBSWCM6XNAVMBES",
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RX32K1VAFDNFT7QE6",
          "01GZCJPJ6R3ZSXMH8JWJN3FFEY",
          "01GZCJPJ6RG1YECVXNYYKKTGSE",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
        ],
      },
      {
        word: "uh",
        displayValue: "uh",
        count: 5,
        turns: [
          "01GZCJPJ6RPFBSWCM6XNAVMBES",
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RX32K1VAFDNFT7QE6",
          "01GZCJPJ6R3ZSXMH8JWJN3FFEY",
          "01GZCJPJ6RG1YECVXNYYKKTGSE",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
        ],
      },
      {
        word: "like",
        displayValue: "like",
        count: 2,
        turns: [
          "01GZCJPJ6RPFBSWCM6XNAVMBES",
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RX32K1VAFDNFT7QE6",
          "01GZCJPJ6R3ZSXMH8JWJN3FFEY",
          "01GZCJPJ6RG1YECVXNYYKKTGSE",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
        ],
      },
      {
        word: "so",
        displayValue: "so",
        count: 1,
        turns: [
          "01GZCJPJ6RPFBSWCM6XNAVMBES",
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RX32K1VAFDNFT7QE6",
          "01GZCJPJ6R3ZSXMH8JWJN3FFEY",
          "01GZCJPJ6RG1YECVXNYYKKTGSE",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
        ],
      },
      {
        word: "hey",
        displayValue: "hey",
        count: 1,
        turns: [
          "01GZCJPJ6RPFBSWCM6XNAVMBES",
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RX32K1VAFDNFT7QE6",
          "01GZCJPJ6R3ZSXMH8JWJN3FFEY",
          "01GZCJPJ6RG1YECVXNYYKKTGSE",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
        ],
      },
    ],
  },
  interruptions: {
    moments: [],
    rate: 0,
    totalCount: 0,
    words: [],
  },
  nonInclusiveTerms: {
    moments: [],
    rate: 0,
    totalCount: 0,
    words: [],
  },
  questions: {
    moments: [
      {
        id: "01GZCJPJ6R4RS3XHE1D55S5T50",
        instances: [
          {
            label: "How do you use Read today?",
            count: 1,
            type: "question",
          },
          {
            label: "What about you?",
            count: 1,
            type: "question",
          },
          {
            label: "What are the things?",
            count: 1,
            type: "question",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:04:47.920-07:00"),
        timestamp: "4:02",
        relativeStartTime: 239.92,
      },
      {
        id: "01GZCJPJ6RZ5B9B3ADD20S5X84",
        instances: [
          {
            label:
              "What are, what are your action items that you need to get done today?",
            count: 1,
            type: "question",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:05:35.188-07:00"),
        timestamp: "4:50",
        relativeStartTime: 287.188,
      },
      {
        id: "01GZCJPJ6RK8NAV4FJMKGTH013",
        instances: [
          {
            label: "How did you use Read to kind of really catch you up?",
            count: 1,
            type: "question",
          },
          {
            label: "How do you use Read on a day to day basis?",
            count: 1,
            type: "question",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:05:52.800-07:00"),
        timestamp: "5:07",
        relativeStartTime: 304.8,
      },
      {
        id: "01GZCJPJ6R91Y5S9V03QX91C74",
        instances: [
          {
            label:
              "Why don't you talk to me about what are some of the pain points that people have with meetings today?",
            count: 1,
            type: "question",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:08:42.093-07:00"),
        timestamp: "7:57",
        relativeStartTime: 474.093,
      },
      {
        id: "01GZCJPJ6R418MHQ97P5TRJ99F",
        instances: [
          {
            label: "How about you, Ro ahead?",
            count: 1,
            type: "question",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T14:11:40.560-07:00"),
        timestamp: "10:55",
        relativeStartTime: 652.56,
      },
    ],
    rate: 5.333333333333334,
    totalCount: 8,
    words: [
      {
        word: "Why don't you talk to me about what are some of the pain points that people have with meetings today?",
        displayValue:
          "Why don't you talk to me about what are some of the pain points that people have with meetings today?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
      {
        word: "What are, what are your action items that you need to get done today?",
        displayValue:
          "What are, what are your action items that you need to get done today?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
      {
        word: "What are the things?",
        displayValue: "What are the things?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
      {
        word: "What about you?",
        displayValue: "What about you?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
      {
        word: "How do you use Read today?",
        displayValue: "How do you use Read today?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
      {
        word: "How do you use Read on a day to day basis?",
        displayValue: "How do you use Read on a day to day basis?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
      {
        word: "How did you use Read to kind of really catch you up?",
        displayValue: "How did you use Read to kind of really catch you up?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
      {
        word: "How about you, Ro ahead?",
        displayValue: "How about you, Ro ahead?",
        count: 1,
        turns: [
          "01GZCJPJ6R4RS3XHE1D55S5T50",
          "01GZCJPJ6RK8NAV4FJMKGTH013",
          "01GZCJPJ6R418MHQ97P5TRJ99F",
          "01GZCJPJ6R91Y5S9V03QX91C74",
          "01GZCJPJ6RZ5B9B3ADD20S5X84",
        ],
      },
    ],
  },
  talkingPace: {
    moments: [
      {
        id: "01GZCJPJ6RPFBSWCM6XNAVMBES",
        instances: [
          {
            color: "rgb(243, 169, 48)",
            label: "212 wpm",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T21:00:51.280Z"),
        timestamp: "0:06",
        relativeStartTime: 4.28,
      },
      {
        id: "01GZCJPJ6RK8NAV4FJMKGTH013",
        instances: [
          {
            color: "rgb(255, 66, 66)",
            label: "254 wpm",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T21:05:48.960Z"),
        timestamp: "5:03",
        relativeStartTime: 302.96,
      },
      {
        id: "01GZCJPJ6RG1YECVXNYYKKTGSE",
        instances: [
          {
            color: "rgb(255, 66, 66)",
            label: "240 wpm",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T21:11:09.920Z"),
        timestamp: "10:24",
        relativeStartTime: 624.92,
      },
      {
        id: "01GZCJPJ6RX32K1VAFDNFT7QE6",
        instances: [
          {
            color: "rgb(213, 179, 62)",
            label: "200 wpm",
          },
        ],
        startTime: DateTime.fromISO("2023-05-01T21:13:08.800Z"),
        timestamp: "12:23",
        relativeStartTime: 744.8,
      },
    ],
    rate: 212,
    totalCount: 0,
    words: [],
  },
};

export const SAMPLE_COACHING_CHARISMA_BIAS: CharismaBiasCoachingData = {
  my: {
    bias: 81,
    charisma: 80,
  },
  participants: [
    {
      id: "11",
      name: "andrew@read.ai",
      talkTime: "0:00",
      talkTimePercent: "-",
      bias: null,
      charisma: null,
    },
    {
      id: "16",
      name: "David Shim",
      talkTime: "5:34",
      talkTimePercent: "40.3%",
      bias: null,
      charisma: null,
    },
    {
      id: "15",
      name: "Elliott W",
      talkTime: "3:01",
      talkTimePercent: "22.1%",
      bias: 80,
      charisma: 81,
    },
    {
      id: "3",
      name: "Luke Woloszyn",
      talkTime: "1:17",
      talkTimePercent: "9.2%",
      bias: 82,
      charisma: 80,
    },
    {
      id: "1",
      name: "Rob Williams",
      talkTime: "2:35",
      talkTimePercent: "20.3%",
      bias: 75,
      charisma: 81,
    },
    {
      id: "11089",
      name: "Rohit Musti",
      talkTime: "1:06",
      talkTimePercent: "8%",
      bias: 81,
      charisma: 79,
    },
  ],
};
